/* jshint esversion: 6 */

const IFrameDomain = {
  lookup: function() {
    const encodedIframeDomainMatch = window.location.search.match(/(\?|&)iframe_domain=([^\&]+)/);
    if (!encodedIframeDomainMatch) return null;

    const encodedIframeDomain = encodedIframeDomainMatch[2];
    if (!encodedIframeDomain) return null;

    return decodeURIComponent(encodedIframeDomain);
  },
};
export default IFrameDomain;
